<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" class="text-right text-sm-left pt-1">
            <i :class="carbonemissions.icon" class="mr-1 text-primary"></i>
            <span class="text-primary">
              {{ carbonemissions.title }} {{ carbonemissions.equipment }}
            </span>
          </b-col>
        </b-row>

        <b-tooltip target="refresh" triggers="hover">Click to refresh</b-tooltip>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm" class="mb-0">
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                    <span style="padding-top: 0.3em" class="text-primary" id="slaclike-tooltip">Like</span>
                    <b-form-checkbox id="slaclike" v-model="slaclike_visible" class="z-0" :disabled="readonly_slac">
                    </b-form-checkbox>
                  </b-input-group>
                  <b-input-group v-if="!slaclike_visible">
                    <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                      :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadSLAC"
                      :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                      search-nested :disabled="readonly_slac">
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-input-group>
                </b-form-group>
                <!-- <b-form-group
                  label-cols="12"
                  label="SL A/C (LIKE %)"
                  label-size="sm"
                > -->
                <b-input-group v-if="slaclike_visible">
                  <b-form-input v-model="slaclike" :disabled="readonly_slac" :debounce="carbonemissions.debounce"
                    placeholder="Client SL A/C (LIKE %)" trim></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" :disabled="!slaclike" @click="slaclike = ''">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <!-- </b-form-group> -->
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..."
                    v-model="eventcode" :multiple="true" :clearable="true" :async="true"
                    :load-options="treeselect_loadEvent" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>


              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-col cols="auto"> -->
                <b-form-group label-cols="12" label="Start Date" label-size="sm">
                  <b-input-group>
                    <daterangepicker size="sm" ref="datetravel" v-model="datetravel" :opens="'right'"
                      :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="true"
                      :single-date-picker="'range'">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="
                        datetravel = {
                          startDate: null,
                          endDate: null,
                        }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Traveller" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="traveller" :debounce="carbonemissions.debounce" placeholder="Traveller" trim>
                    </b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!traveller" @click="traveller = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Start City" label-size="sm">
                  <treeselect placeholder="Select start city..." searchPromptText="Type at least 3 chars..."
                    :multiple="true" :clearable="true" :async="true" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested :load-options="treeselect_loadIATA"
                    v-model="startcity">
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>

              <b-col v-if="labelendcity" cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" :label="labelendcity" label-size="sm">
                  <treeselect placeholder="Select end city..." searchPromptText="Type at least 3 chars..."
                    :multiple="true" :clearable="true" :async="true" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested :load-options="treeselect_loadIATA"
                    v-model="endcity">
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Anonymiser"
                  label-size="sm"
                >
                  <treeselect
                    placeholder="Select..."
                    v-model="anonymiser"
                    :clearable="false"
                    :options="anonymiser_options"
                    :show-count="true"
                    :flatten-search-results="true"
                    :disable-branch-nodes="true"
                    :matchKeys="['id']"
                    search-nested
                    :disabled="readonly"
                  >
                  </treeselect>
                </b-form-group>
              </b-col> -->
              <b-col v-if="labelsupplier" cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" :label="labelsupplier" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="supplier" :debounce="carbonemissions.debounce" :placeholder="labelsupplier"
                      trim>
                    </b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!supplier" @click="supplier = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col v-if="labelquantity" cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" :label="labelquantity" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="quantity" :debounce="carbonemissions.debounce" :placeholder="labelquantity"
                      trim>
                    </b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!quantity" @click="quantity = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col v-if="labelduration" cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" :label="labelduration" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="duration" :debounce="carbonemissions.debounce" :placeholder="labelduration"
                      trim>
                    </b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!duration" @click="duration = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col v-if="labeldistance" cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" :label="labeldistance" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="distance" :debounce="carbonemissions.debounce" :placeholder="labeldistance"
                      trim>
                    </b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!distance" @click="distance = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col v-if="labelcategory" cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" :label="labelcategory" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="category" :debounce="carbonemissions.debounce" :placeholder="labelcategory"
                      trim>
                    </b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!category" @click="category = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col v-if="labelflightno" cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" :label="labelflightno" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="flightno" :debounce="carbonemissions.debounce" :placeholder="labelflightno"
                      trim>
                    </b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!flightno" @click="flightno = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col v-if="labelconfirmationno" cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" :label="labelconfirmationno" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="confirmationno" :debounce="carbonemissions.debounce"
                      :placeholder="labelconfirmationno" trim>
                    </b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!confirmationno"
                        @click="confirmationno = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col v-if="labelequipment" cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" :label="labelequipment" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="equipment" :debounce="carbonemissions.debounce" :placeholder="labelequipment"
                      trim>
                    </b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!equipment" @click="equipment = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col v-if="labelticketno" cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" :label="labelticketno" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="ticketno" :debounce="carbonemissions.debounce" :placeholder="labelticketno"
                      trim>
                    </b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!ticketno" @click="ticketno = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>

        <div id="carbonemissions" class="px-3 mx-0 text-left">
          <div v-if="carbonemissions.pastespecial">
            <b-row class="mt-2" no-gutters>
              <b-col cols="6">
                <b-form-group>
                  <b-form-checkbox-group id="segments_paste_selected" v-model="carbonemissions.paste_selected"
                    :options="carbonemissions.paste_options" value-field="id"
                    text-field="label"></b-form-checkbox-group>
                </b-form-group>
              </b-col>
              <b-col cols="auto" class="text-right ml-auto">
                <b-row>
                  <b-col cols="auto">
                    <b-link squared size="sm" variant="outline-primary" @click="download()">
                      <i class="fa fa-download"></i>
                      Template
                    </b-link>
                  </b-col>
                  <b-col cols="auto">
                    <b-link size="sm" variant="outline-primary" @click="carbonemissions_saveit()">
                      <i class="fa fa-floppy-o"></i>
                      Save It
                    </b-link>
                  </b-col>
                  <b-col cols="auto">
                    <b-link size="sm" variant="outline-primary" @click="carbonemissions_headers()">
                      Headers
                    </b-link>
                  </b-col>
                  <b-col cols="auto">
                    <b-link size="sm" variant="outline-primary" @click="carbonemissions_paste_read()">
                      <i class="fa fa-magic"></i>
                      Read It
                    </b-link>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label-cols="12">
                  <b-form-textarea id="data" v-model="carbonemissions.paste" placeholder="Paste segment data" rows="6"
                    class="smalltextarea courier"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <!-- :toolbar="carbonemissions.toolbar" -->
          <d-table classdivtable="availtable datatable sheets" refid="carbonemissions" :icon="carbonemissions.icon"
            :toolbarlibrary="carbonemissions.toolbarlibrary" :tools="carbonemissions.tools"
            :badges="carbonemissions.badges" :fields="carbonemissions.fields" :items="carbonemissions.items"
            :busy="carbonemissions.busy" :showpages="true" :showsheets="true" :offset="carbonemissions.offset"
            :limit="carbonemissions.limit" :page="carbonemissions.page" @load="carbonemissions_load"
            @click="carbonemissions_click" @select="carbonemissions_select">
          </d-table>
        </div>
      </div>

      <!-- :selection="selected"
      :config="{ type: carbonemissions.sheet.slice(-1) }" -->
      <div v-if="component">
        <component :is="component" :variables="variables" :selection="carbonemissions.selected"
          @discard="carbonemissions_click('discard')"></component>
      </div>
    </b-card>
    <!-- <CarbonEmissionsWizard @refresh="carbonemissions_load" /> -->
  </div>
</template>

<script>
import gql from "graphql-tag";

import dateparse from 'any-date-parser';

import * as fs from "file-saver";

import CarbonEmissionsEdit from "./Components/CarbonEmissionsEdit";
import CarbonEmissionImport from "./Components/CarbonEmissionImport";
import CarbonEmissionsEditM from "./Components/CarbonEmissionsEditM";
// import CarbonEmissionsWizard from "./Components/CarbonEmissionsWizard";


function tabToObjArr(text) {

  let raw = text.trim().split('"').join("")
  let allcols = raw.split("\t")

  let headers = raw.split("\n")[0].split("\t")
  let cb = headers.length - 1
  let cols = []
  for (let i = 0; i < allcols.length; i++) {
    if (i == cb) {
      let parts = allcols[i].trim().split("\n")
      for (let k = 0; k < parts.length; k++) {
        cols.push(parts[k].trim())
      }
      cb += headers.length - 1
    } else {
      cols.push(allcols[i].trim().split("\n").join(",").replace(/\s+/g, ' '))
    }
  }
  console.log('cols=', cols)

  cb = headers.length - 1
  let rows = []
  let item = {}
  let k = 0
  for (let i = 0; i < cols.length; i++) {
    if (i == cb) {
      item[headers[k]] = cols[i]
      rows.push(item)
      cb += headers.length
      item = {}
      k = 0
    } else {
      item[headers[k]] = cols[i]
      k += 1
    }
  }
  return rows;
}

export default {
  name: "ClientEmissions",
  components: {
    CarbonEmissionsEdit,
    CarbonEmissionsEditM,
    // CarbonEmissionsWizard,
    CarbonEmissionImport
  },
  props: {
    search: { type: Object },
  },
  async mounted() {
    this.sheetlabels();
    if (this.search.slac) {
      this.slac = [this.search.slac]
    }
    await this.carbonemissions_load();
  },
  computed: {
    sheetname() {
      //let tools = this.carbonemissions.toolbar;
      //if (tools.length > 0) {
      //  return tools.find((o) => o.action == "sheet_" + this.type).label;
      //}
    },
    sheeticon() {
      //let tools = this.carbonemissions.toolbar;
      //if (tools.length > 0) {
      //  return tools.find((o) => o.action == "sheet_" + this.type).icon;
      //}
    },

    variables() {
      return {
        travel_at: [
          this.datetravel.startDate
            ? this.$moment(this.datetravel.startDate).format("YYYY-MM-DD")
            : null,
          this.datetravel.endDate
            ? this.$moment(this.datetravel.endDate).format("YYYY-MM-DD")
            : null,
        ],
        slac: this.slac.length > 0 ? this.slac.join(",") : null,
        eventcode: this.eventcode.length > 0 ? this.eventcode.join(",") : null,
        traveller: this.traveller,
        type: this.type,
        startcity: this.startcity.length > 0 ? this.startcity.join(",") : null,

        duration: this.duration,
        quantity: this.quantity,
        distance: this.distance,
        category: this.category,
        flightno: this.flightno,
        confirmationno: this.confirmationno,
        equipment: this.equipment,
        ticketno: this.ticketno,
        supplier: this.supplier,
        endcity: this.endcity.length > 0 ? this.endcity.join(",") : null,
      };
    },

    labelquantity() {
      if (this.carbonemissions.fields.length > 0) {
        let field = this.carbonemissions.fields.find(
          (o) => o.key == "quantity"
        );
        if (field) {
          return field.label;
        } else {
          return null;
        }
      }
    },

    labelsupplier() {
      if (this.sheetname == "Accommodation" || this.sheetname == "Rail") {
        if (this.carbonemissions.fields.length > 0) {
          let field = this.carbonemissions.fields.find(
            (o) => o.key == "supplier"
          );
          if (field) {
            return field.label;
          } else {
            return null;
          }
        }
      } else {
        return null;
      }
    },

    labelduration() {
      if (this.sheetname == "Accommodation") {
        if (this.carbonemissions.fields.length > 0) {
          let field = this.carbonemissions.fields.find(
            (o) => o.key == "duration"
          );
          if (field) {
            return field.label;
          } else {
            return null;
          }
        }
      } else {
        return null;
      }
    },
    labelendcity() {
      if (this.sheetname == "Rail" || this.sheetname == "Flight") {
        if (this.carbonemissions.fields.length > 0) {
          let field = this.carbonemissions.fields.find(
            (o) => o.key == "endcity"
          );
          if (field) {
            return field.label;
          } else {
            return null;
          }
        }
      } else {
        return null;
      }
    },

    labeldistance() {
      if (this.sheetname != "Accommodation") {
        if (this.carbonemissions.fields.length > 0) {
          let field = this.carbonemissions.fields.find(
            (o) => o.key == "distance"
          );
          if (field) {
            return field.label;
          } else {
            return null;
          }
        }
      } else {
        return null;
      }
    },

    labelcategory() {
      if (this.sheetname != "Accommodation") {
        if (this.carbonemissions.fields.length > 0) {
          let field = this.carbonemissions.fields.find(
            (o) => o.key == "category"
          );
          if (field) {
            return field.label;
          } else {
            return null;
          }
        }
      } else {
        return null;
      }
    },

    labelflightno() {
      if (this.sheetname == "Flight") {
        if (this.carbonemissions.fields.length > 0) {
          let field = this.carbonemissions.fields.find(
            (o) => o.key == "flightno"
          );
          if (field) {
            return field.label;
          } else {
            return null;
          }
        }
      } else {
        return null;
      }
    },
    labelconfirmationno() {
      if (this.sheetname == "Flight") {
        if (this.carbonemissions.fields.length > 0) {
          let field = this.carbonemissions.fields.find(
            (o) => o.key == "confirmationno"
          );
          if (field) {
            return field.label;
          } else {
            return null;
          }
        }
      } else {
        return null;
      }
    },
    labelequipment() {
      if (this.sheetname == "Flight") {
        if (this.carbonemissions.fields.length > 0) {
          let field = this.carbonemissions.fields.find(
            (o) => o.key == "equipment"
          );
          if (field) {
            return field.label;
          } else {
            return null;
          }
        }
      } else {
        return null;
      }
    },
    labelticketno() {
      if (this.sheetname == "Flight") {
        if (this.carbonemissions.fields.length > 0) {
          let field = this.carbonemissions.fields.find(
            (o) => o.key == "ticketno"
          );
          if (field) {
            return field.label;
          } else {
            return null;
          }
        }
      } else {
        return null;
      }
    },
    readonly_slac() {
      if (this.search.slac) {
        return true
      }
      return false
    },
  },
  data() {
    return {
      busy: false,
      readonly: false,
      type: "0",
      datetravel: {
        startDate: null, //this.$moment().startOf("year").format("YYYY-MM-DD"),
        endDate: null, //this.$moment().format("YYYY-MM-DD"),
      },
      slac: [],
      slaclike: null,
      slaclike_visible: null,
      eventcode: [],
      traveller: "",
      startcity: [],
      duration: "",
      quantity: "",
      distance: "",
      category: "",
      flightno: "",
      confirmationno: "",
      equipment: "",
      ticketno: "",
      supplier: "",
      endcity: [],
      anonymiser: false,
      carbonemissions: {
        title: "Client Emissions",
        icon: "fa fa-globe text-primary",
        equipment: "",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        denied: [],
        toolbar: [],
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-user-secret",
            position: "toolbar",
            action: "annon",
            label: "Anonymiser Off",
          },
        ],
        edit: false,
        pastespecial: false,
        paste: null,
        paste_selected: ["firstrowheader", "reversenamecap"],
        paste_options: [
          { id: "firstrowheader", label: "First Row Headers", disabled: true },
          { id: "secondrowskip", label: "Second Row Skip" },
          { id: "filldown", label: "Fill Down" },
        ],
        tools: "go,filter,export,clipboard,add,edit,pastespecial,deleteconfirm,annon,sheet_0,sheet_1,sheet_2,sheet_3,sheet_4,sheet_5",
        fields: [],
        fields_0: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "w-50px text-right text-primary nowrap",
          },
          {
            key: "eventcode",
            label: "Event",
            class: "text-center",
            sortable: true,
          },
          {
            key: "slac",
            label: "Client SL A/C",
            class: "text-center",
            sortable: true,
          },
          {
            key: "start_at",
            label: "Start Date",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("YYYY-MM-DD HH:mm");
              }
              return result;
            },
          },
          {
            key: "traveller",
            label: "Traveller",
            class: "text-left",
            sortable: true,
          },
          {
            key: "quantity",
            label: "Qty",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
            type: "int",
          },
          {
            key: "startcity",
            label: "Start City",
            sortable: true,
            class: "text-center",
          },

          {
            key: "endcity",
            label: "End City",
            sortable: true,
            class: "text-center",
          },
          {
            key: "equipment",
            label: "Aircraft",
            sortable: true,
            class: "text-center",
          },
          {
            key: "flightno",
            label: "FlightNo",
            sortable: true,
            class: "text-center",
          },
          {
            key: "confirmationno",
            label: "Locator",
            sortable: true,
            class: "text-center",
          },
          {
            key: "ticketno",
            label: "TicketNo",
            sortable: true,
            class: "text-center",
          },
          {
            key: "category",
            label: "Cabin",
            sortable: true,
            class: "text-center",
          },
          {
            key: "supplier",
            label: "Supplier",
            sortable: true,
            class: "text-right",
          },

          {
            key: "distance",
            label: "Distance KM",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
            type: "int",
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        fields_1: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "w-50px text-right text-primary nowrap",
          },
          {
            key: "id",
            label: "ID",
            class: "d-none",
            sortable: true,
          },
          {
            key: "eventcode",
            label: "Event",
            class: "text-center",
            sortable: true,
          },
          {
            key: "slac",
            label: "Client SL A/C",
            class: "text-center",
            sortable: true,
          },
          {
            key: "start_at",
            label: "Start Date",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("YYYY-MM-DD HH:mm");
              }
              return result;
            },
          },
          {
            key: "traveller",
            label: "Traveller",
            class: "text-left",
            sortable: true,
          },
          {
            key: "quantity",
            label: "Qty",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
            type: "int",
          },
          {
            key: "startcity",
            label: "Start City",
            sortable: true,
            class: "text-center",
          },

          {
            key: "equipment",
            label: "Hotel",
            sortable: true,
          },
          {
            key: "category",
            label: "Room Type",
            sortable: true,
          },
          {
            key: "quantity",
            label: "No of Rooms",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
            type: "int",
          },
          {
            key: "duration",
            label: "No of Nights",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
            type: "int",
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        fields_2: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "w-50px text-right text-primary nowrap",
          },
          {
            key: "eventcode",
            label: "Event",
            class: "text-center",
            sortable: true,
          },
          {
            key: "slac",
            label: "Client SL A/C",
            class: "text-center",
            sortable: true,
          },

          {
            key: "start_at",
            label: "Start Date",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("YYYY-MM-DD HH:mm");
              }
              return result;
            },
          },
          {
            key: "traveller",
            label: "Traveller",
            class: "text-left",
            sortable: true,
          },
          {
            key: "quantity",
            label: "Qty",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
            type: "int",
          },
          {
            key: "startcity",
            label: "Start City",
            sortable: true,
            class: "text-center",
          },
          {
            key: "equipment",
            label: "Equipment",
            sortable: true,
            class: "text-right",
          },
          {
            key: "supplier",
            label: "Supplier",
            sortable: true,
            class: "text-right",
          },
          {
            key: "distance",
            label: "Distance KM",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
            type: "int",
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        fields_3: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "w-50px text-right text-primary nowrap",
          },
          {
            key: "eventcode",
            label: "Event",
            class: "text-center",
            sortable: true,
          },
          {
            key: "slac",
            label: "Client SL A/C",
            class: "text-center",
            sortable: true,
          },

          {
            key: "start_at",
            label: "Start Date",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("YYYY-MM-DD HH:mm");
              }
              return result;
            },
          },
          {
            key: "traveller",
            label: "Traveller",
            class: "text-left",
            sortable: true,
          },
          {
            key: "quantity",
            label: "Qty",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
            type: "int",
          },
          {
            key: "startcity",
            label: "Start City",
            sortable: true,
            class: "text-center",
          },

          {
            key: "endcity",
            label: "End City",
            sortable: true,
            class: "text-center",
          },
          {
            key: "equipment",
            label: "Equipment",
            sortable: true,
            class: "text-center",
          },
          {
            key: "distance",
            label: "Journey KM",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
            type: "int",
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        fields_4: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "w-50px text-right text-primary nowrap",
          },
          {
            key: "eventcode",
            label: "Event",
            class: "text-center",
            sortable: true,
          },
          {
            key: "slac",
            label: "Client SL A/C",
            class: "text-center",
            sortable: true,
          },

          {
            key: "start_at",
            label: "Start Date",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("YYYY-MM-DD HH:mm");
              }
              return result;
            },
          },
          {
            key: "traveller",
            label: "Traveller",
            class: "text-left",
            sortable: true,
          },
          {
            key: "quantity",
            label: "Qty",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
            type: "int",
          },
          {
            key: "startcity",
            label: "Start City",
            sortable: true,
            class: "text-center",
          },

          {
            key: "category",
            label: "Rail Type",
            sortable: true,
            class: "text-right",
          },
          {
            key: "supplier",
            label: "Supplier",
            sortable: true,
            class: "text-right",
          },
          {
            key: "distance",
            label: "Distance KM",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
            type: "int",
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        // fields_5: [
        //   {
        //     key: "selected",
        //     label: "...",
        //     class: "text-center w-25px",
        //   },
        //   {
        //     key: "icon",
        //     label: "",
        //     class: "w-50px text-right text-primary nowrap",
        //   },
        //   {
        //     key: "eventcode",
        //     label: "Event",
        //     class: "text-center",
        //     sortable: true,
        //   },
        //   {
        //     key: "slac",
        //     label: "Client SL A/C",
        //     class: "text-center",
        //     sortable: true,
        //   },

        //   {
        //     key: "start_at",
        //     label: "Start Date",
        //     sortable: true,
        //     class: "text-center",
        //     formatter: (value, key, item) => {
        //       let result = "";
        //       if (value) {
        //         result = this.$moment
        //           .unix(value / 1000)
        //           .utc(false)
        //           .format("YYYY-MM-DD HH:mm");
        //       }
        //       return result;
        //     },
        //   },
        //   {
        //     key: "traveller",
        //     label: "Traveller",
        //     class: "text-left",
        //     sortable: true,
        //   },
        //   {
        //     key: "startcity",
        //     label: "Start City",
        //     sortable: true,
        //     class: "text-center",
        //   },

        //   {
        //     key: "category",
        //     label: "Coach Type",
        //     sortable: true,
        //     class: "text-right",
        //   },
        //   {
        //     key: "supplier",
        //     label: "Supplier",
        //     sortable: true,
        //     class: "text-right",
        //   },
        //   {
        //     key: "distance",
        //     label: "Distance KM",
        //     sortable: true,
        //     class: "text-right",
        //     totalled: true,
        //     total: 0,
        //     type: "int",
        //   },
        //   {
        //     key: "updated_by",
        //     label: "Updated By",
        //     sortable: true,
        //   },
        //   {
        //     key: "updated_at",
        //     label: "Updated At",
        //     sortable: true,
        //   },
        //   {
        //     key: "actions",
        //     label: "Actions",
        //     class: "actions w-100px",
        //   },
        // ],
        fields_5: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "w-50px text-right text-primary nowrap",
          },
          {
            key: "eventcode",
            label: "Event",
            class: "text-center",
            sortable: true,
          },
          {
            key: "slac",
            label: "Client SL A/C",
            class: "text-center",
            sortable: true,
          },

          {
            key: "start_at",
            label: "Start Date",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("YYYY-MM-DD HH:mm");
              }
              return result;
            },
          },
          {
            key: "traveller",
            label: "Traveller",
            class: "text-left",
            sortable: true,
          },
          {
            key: "quantity",
            label: "Qty",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
            type: "int",
          },
          {
            key: "startcity",
            label: "Start City",
            sortable: true,
            class: "text-center",
          },

          {
            key: "category",
            label: "Ferry Type",
            sortable: true,
            class: "text-right",
          },
          {
            key: "supplier",
            label: "Supplier",
            sortable: true,
            class: "text-right",
          },
          {
            key: "distance",
            label: "Distance KM",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
            type: "int",
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],

        badges: [],
        items: [],
        selected: [],
      },
    };
  },
  watch: {
    async type() {
      this.carbonemissions.fields = this.carbonemissions["fields_" + this.type];
      this.duration = null;
      this.quantity = null;
      this.distance = null;
      this.category = null;
      this.ticketno = null;
      this.flightno = null;
      this.confirmationno = null;
      this.equipment = null;
      this.supplier = null;
      this.endcity = [];
      await this.carbonemissions_load(0);
    },
    async eventcode() {
      await this.carbonemissions_load(0);
    },
    async slac() {
      await this.carbonemissions_load(0);
    },
    async slaclike_visible() {
      await this.carbonemissions_load(0);
    },
    async slaclike() {
      await this.carbonemissions_load(0);
    },
    async datetravel() {
      await this.carbonemissions_load(0);
    },
    async traveller() {
      await this.carbonemissions_load(0);
    },
    async anonymiser() {
      await this.carbonemissions_load(0);
    },
    async startcity() {
      await this.carbonemissions_load(0);
    },
    async duration() {
      await this.carbonemissions_load(0);
    },
    async quantity() {
      await this.carbonemissions_load(0);
    },
    async distance() {
      await this.carbonemissions_load(0);
    },
    async category() {
      await this.carbonemissions_load(0);
    },
    async ticketno() {
      await this.carbonemissions_load(0);
    },
    async flightno() {
      await this.carbonemissions_load(0);
    },
    async confirmationno() {
      await this.carbonemissions_load(0);
    },
    async equipment() {
      await this.carbonemissions_load(0);
    },
    async supplier() {
      await this.carbonemissions_load(0);
    },
    async endcity() {
      await this.carbonemissions_load(0);
    },
  },
  methods: {
    async carbonemissions_load(offset, limit, page) {
      console.log("load", offset, limit, page);

      let state = this.carbonemissions;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,

        travel_at: [
          this.datetravel.startDate
            ? this.$moment(this.datetravel.startDate).format("YYYY-MM-DD")
            : null,
          this.datetravel.endDate
            ? this.$moment(this.datetravel.endDate).format("YYYY-MM-DD")
            : null,
        ],
        slac: this.slac.length > 0 ? this.slac.join(",") : null,
        slaclike: this.slaclike,
        eventcode: this.eventcode.length > 0 ? this.eventcode.join(",") : null,
        traveller: this.traveller,
        anonymiser: this.anonymiser,
        type: this.type,
        startcity: this.startcity.length > 0 ? this.startcity.join(",") : null,
        endcity: this.endcity.length > 0 ? this.endcity.join(",") : null,
        ticketno: this.ticketno,
        flightno: this.flightno,
        confirmationno: this.confirmationno,
        vehicle: this.equipment,
        duration: this.duration,
        quantity: this.quantity,
        distance: this.distance,
        category: this.category,
        supplier: this.supplier,
      };

      console.log("carbonemissions variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query carbonemissions(
              $offset: Int
              $limit: Int
              $type: String
              $eventcode: String
              $slac: String
              $slaclike: String
              $travel_at: [String]
              $traveller: String
              $startcity: String
              $duration: String
              $quantity: String
              $distance: String
              $category: String
              $ticketno: String
              $flightno: String
              $confirmationno: String
              $vehicle: String
              $supplier: String
              $endcity: String
              $anonymiser: Boolean
              $dateformat: String
            ) {
              carbonemissions(
                offset: $offset
                limit: $limit
                type: $type
                eventcode: $eventcode
                slac: $slac
                slaclike: $slaclike
                travel_at: $travel_at
                traveller: $traveller
                startcity: $startcity
                duration: $duration
                quantity: $quantity
                distance: $distance
                category: $category
                ticketno: $ticketno
                flightno: $flightno
                confirmationno: $confirmationno
                vehicle: $vehicle
                supplier: $supplier
                endcity: $endcity
                anonymiser: $anonymiser
                dateformat: $dateformat
              ) {
                id
                type
                eventcode
                slac
                traveller
                start_at
                startcity
                flightno
                confirmationno
                equipment: vehicle
                ticketno
                duration
                quantity
                distance
                category
                supplier
                end_at
                endcity
                updated_at
                updated_by
                rows
              }
            }
          `,
          variables,
        });

        this.carbonemissions.fields =
          this.carbonemissions["fields_" + this.type];

        // USE LOCAL VARIABLE
        if (limit == 0) {
          state.selected = response.data.carbonemissions
        } else {
          state.items = response.data.carbonemissions;
        }

      } catch (error) {
        console.log(error);
      }


      state.busy = false;
    },
    async carbonemissions_click(a, ss) {
      console.log("carbonemissions_click", a, ss);

      let state = this.carbonemissions;

      switch (a) {
        case "filter":
          this.showfilter = !this.showfilter;
          break;

        case "discard":
          this.component = null;
          break;

        case "go":
          this.component = null;
          await this.carbonemissions_load(0);
          break;

        case "pastespecial":
          state.pastespecial = !state.pastespecial
          break;

        case "add":
        case "edit":
          this.component = "CarbonEmissionsEdit";
          break;
        case "import":
          this.component = "CarbonEmissionImport";
          break;
        case "sheet_0":
        case "sheet_1":
        case "sheet_2":
        case "sheet_3":
        case "sheet_4":
        case "sheet_5":
        case "sheet_6":
          this.type = a.slice(-1);
          break;
        case "annon":
          this.anonymiser = !this.anonymiser
          break;
        case "wizard":
          this.$bvModal.show("carbonemissions-wizard");
          break;

        case "delete":
          this.carbonemissions_deleteit(ss);
          break;
      }
    },
    async carbonemissions_select(ss, tools) {
      console.log("carbonemissions_select", ss, tools);

      let state = this.carbonemissions;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = [
          "back",
          "save",
          "go",
          "filter",
          "add",
          "import",
          "export",
          "pastespecial",
          "wizard",
          "annon",
          "clipboard"
        ];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit", "notes"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm", "chart"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        let found = tools.find(
          (o) => o.action == "annon"
        );
        if (this.anonymiser == true) {
          found.label = "Anonymiser On";
        } else if (this.anonymiser == false) {
          found.label = "Anonymiser Off";
        }

        this.sheetlabels(tools)

        state.icon = tools.find((o) => o.action == "sheet_" + this.type).icon;
        state.equipment = tools.find((o) => o.action == "sheet_" + this.type).label;

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async carbonemissions_headers() {

      let state = this.carbonemissions;

      let content = state.paste
      state.paste = "SegmentNo\tStart City\tStart Location\tStart Datetime\tEnd City\tEnd Location\tEnd Datetime\tCabin\tDuration\tClass\tClassname\tEquipment\tSupplier\tFare\tTax\n"
      if (content) {
        state.paste += content
      }
    },
    async carbonemissions_paste_read() {

      let state = this.carbonemissions;

      if (state.paste) {

        state.busy = true
        let rows = tabToObjArr(state.paste)
        console.log('rows=', rows)

        let rowstart = 1
        if (state.paste_selected.includes("secondrowskip")) {
          rowstart += 1
        }

        // MAKE OBJECT ITEMS
        let items = []
        for (let i = rowstart; i < rows.length; i++) {
          items.push(rows[i])
        }
        console.log('items', items)

        if (state.paste_selected.includes("filldown")) {
          let lastitem = {}
          for (let i = 0; i < items.length; i++) {
            let item = items[i]
            for (let prop in lastitem) {
              if (!item[prop]) {
                if (lastitem[prop]) {
                  item[prop] = lastitem[prop]
                }
              }
            }
            lastitem = item
          }
        }
        console.log('fill downs', rows)

        let found = null

        rows = []
        for (let i = 0; i < items.length; i++) {
          let obj = items[i]

          let segment = {}

          let start_at = ""
          let end_at = ""
          let datetravel = ""
          let parts = []
          for (let prop in obj) {

            try {
              if (obj[prop]) {
                let data = obj[prop].trim().toUpperCase()
                let colname = prop.toLowerCase()

                // if (colname == 'segmentname') {
                //   segment.segmentname = data
                // }
                // if (colname == 'segmentgroup') {
                //   segment.segmentgroup = data
                // }

                if (colname == 'type') {
                  switch (data) {
                    case "AIR":
                      data = "0"
                      break;
                    case "HTL":
                      data = "1"
                      break;
                    case "CAR":
                      data = "2"
                      break;
                    case "XFR":
                      data = "3"
                      break;
                    case "RAI":
                      data = "4"
                      break;
                    case "SEA":
                      data = "5"
                      break;
                  }
                  segment.type = data
                }

                if (colname == 'eventcode') {
                  segment.eventcode = data
                }
                if (colname == 'slac') {
                  segment.slac = data
                }

                if (colname == 'traveller' || colname == 'mob' || colname == 'name' || colname == 'names') {
                  parts = data.split(",")
                  let traveller = { paxtype: "ADT", passenger: "" }
                  let passenger = ""
                  for (let k = 0; k < parts.length; k++) {
                    let nameinput = parts[k].trim()
                    if (nameinput) {
                      if (nameinput.includes("/")) {
                        let names = nameinput.split('/')
                        names = names.filter(item => item);
                        // names = names.reverse()
                        traveller.surname = names[0]
                        names.shift()
                        traveller.firstname = names.join(" ")
                        if (traveller.passenger.length > 0) { traveller.passenger += "," }
                        traveller.passenger += traveller.surname + "/" + traveller.firstname
                      } else if (nameinput.length > 2) {
                        let names = nameinput.split(' ')
                        names = names.filter(item => item);
                        names = names.reverse()

                        traveller.surname = names[0]
                        names.shift()
                        traveller.firstname = names.join(" ")
                        traveller.passenger += traveller.surname + "/" + traveller.firstname
                        if (traveller.passenger.length > 0) { traveller.passenger += "," }
                        if (k + 1 < parts.length) {
                          if (parts[k + 1].trim().slice(0, 1) == "+") {
                            traveller.mob = parts[k + 1].trim()
                            parts[k + 1] = ""
                          }
                        }
                      }
                    }
                    if (k == 0) {
                      passenger = traveller.passenger
                    }
                    segment.traveller = traveller.passenger
                  }
                  if (parts.length > 0) {
                    segment.seats = parts.length
                    segment.data = segment.traveller
                    segment.traveller = passenger
                  }
                }
                if (colname == 'surname') {
                  let names = data.trim().toUpperCase().split('/')
                  let namef = []
                  if (obj["firstname"]) {
                    namef = obj["firstname"].trim().toUpperCase().split('/')
                  }
                  let passenger = ""
                  for (let k = 0; k < names.length; k++) {
                    if (k > 0) {
                      passenger += ","
                    }
                    passenger += names[k].trim() + "/" + namef[k].trim()
                  }
                  segment.traveller = passenger

                  // traveller.surname = data.toUpperCase()
                  // if (obj["firstname"]) {
                  //   traveller.firstname = obj["firstname"].toUpperCase()
                  //   traveller.passenger = traveller.surname + "/" + traveller.firstname
                  //   segment.traveller = traveller.passenger
                  // }
                }


                if (colname == 'startcity' || colname == 'start city') {
                  segment.startcity = data
                }
                if (colname == 'startlocation' || colname == 'start location' || colname == 'departure station' || colname == 'pick up' || colname == 'pickup') {
                  segment.startlocation = data
                }
                if (colname == 'startdate' || colname == 'start datetime' || colname == 'date' || colname == 'checkin') {

                  let st = dateparse.fromString(data.split("/").join("-").split(".").join("-"));
                  console.log('parsed as', st)
                  segment.start_at = this.$moment(st).utc(false).format('YYYY-MM-DD HH:mm')
                  console.log('moment as', segment.start_at)
                  segment.start_at = (this.$moment(segment.start_at).utc(true).unix() * 1000).toString()
                }
                if (colname == 'endcity' || colname == 'end city') {
                  segment.endcity = data
                }
                if (colname == 'endlocation' || colname == 'end location' || colname == 'arrival station' || colname == 'drop off' || colname == 'dropoff') {
                  segment.endlocation = data
                }
                if (colname == 'enddate' || colname == 'end datetime' || colname == 'enddate' || colname == 'checkout') {
                  let st = dateparse.fromString(data.split("/").join("-").split(".").join("-"));
                  console.log('parsed as', st)
                  segment.end_at = this.$moment(st).utc(false).format('YYYY-MM-DD HH:mm')
                  console.log('moment as', segment.end_at)
                  segment.end_at = (this.$moment(segment.end_at).utc(true).unix() * 1000).toString()
                }

                if (colname == 'departure' || colname == 'departure time') {
                  data = data.split(' ').join('').split(':').join('')
                  if (data.length < 4) {
                    data = "0" + data
                  }
                  start_at = data.slice(0, 2)
                  start_at += ":"
                  start_at += data.slice(-2)
                }
                if (colname == 'arrival' || colname == 'arrival time') {
                  data = data.split(' ').join('').split(':').join('')
                  if (data.length < 4) {
                    data += "0"
                  }
                  end_at = data.slice(0, 2)
                  end_at += ":"
                  end_at += data.slice(-2)
                }
                if (colname == 'equipment' || colname == 'aircraft') {
                  segment.equipment = data
                }
                if (colname == 'supplier' || colname == 'airline') {
                  segment.supplier = data
                }
                if (colname == 'duration' || colname == "nights" || colname == 'journey time') {
                  // parts = data.split(' ')
                  segment.duration = data
                }
                if (colname == 'distance') {
                  // parts = data.split(' ')
                  segment.distance = data
                }
                if (colname == 'qty' || colname == 'quantity') {
                  // parts = data.split(' ')
                  segment.quantity = data
                }
                // if (colname == 'classcode') {
                //   // parts = data.split(' ')
                //   segment.classcode = data
                // }

                if (colname == 'classname' || colname == 'ticket type' || colname == 'roomtype') {
                  // parts = data.split(' ')
                  segment.category = data
                }
                // if (colname == 'classname' || colname == 'ticket type') {
                //   segment.classname = data
                //   if (data.toLowerCase().includes('business')) {
                //     segment.cabin = "BUSINESS"
                //   }
                //   if (data.toLowerCase().includes('1st')) {
                //     segment.cabin = "FIRST"
                //   }
                // }
                // if (colname == 'seats') {
                //   segment.seats = data.toUpperCase().split("SEATER").join("").trim()
                //   if (segment.seats.includes('-')) {
                //     let parts = segment.seats.split('-')
                //     segment.seats = parts[1].trim()
                //   }
                //   // if (!parseInt(segment.seats)) {
                //   //     segment.seats = segment.seats.slice(-1)
                //   // }
                // }
                if (colname == 'notes') {
                  // segment.notes = data
                }
                // if (colname == 'fare') {
                //   segment.fare = parseFloat(data.split(',').join('')).toFixed(2)
                // }
                // if (colname == 'tax') {
                //   segment.tax = parseFloat(data.split(',').join('')).toFixed(2)
                // }
                if (colname == 'ticketno') {
                  // parts = data.split(' ')
                  segment.ticketno = data
                }
                if (colname == 'flightno') {
                  // parts = data.split(' ')
                  segment.flightno = data
                }
              }

            } catch (error) {
              console.log('error here', error)
            }

          }
          if (segment.startcity && segment.endcity) {
            segment.route = segment.startcity + "/" + segment.endcity
          }
          if (!segment.route && segment.startlocation && segment.endlocation) {
            parts = segment.startlocation.split(' ')
            segment.route = parts[0]
            segment.route += "/"
            parts = segment.endlocation.split(' ')
            segment.route += parts[0]
          }
          // if (!segment.equipment && (segment.seats && segment.type == "XFR") && (segment.seats && segment.type == 3))
          if (!segment.equipment && (segment.qty && segment.type == "XFR") && (segment.qty && segment.type == 3)) {
            if (parseFloat(segment.qty) > 20) {
              segment.equipment = "COACH"
            }
            if (parseFloat(segment.qty) > 7 && parseFloat(segment.qty) <= 20) {
              segment.equipment = "MINIBUS"
            }
            if (parseFloat(segment.qty) > 0 && parseFloat(segment.qty) < 7) {
              segment.equipment = "TAXI"
            }
            if (parseFloat(segment.qty) == 0) {
              segment.equipment = "MINIVAN"
            }
          }
          if (this.segmentgroup) {
            segment.segmentgroup = this.segmentgroup.trim().toUpperCase()
          }
          if (!segment.quantity) {
            segment.quantity = "1"
          }
          if (!segment.type) {
            segment.type = this.type
          }

          segment.category = segment.classname
          segment.vehicle = segment.equipment

          delete segment.seats

          rows.push(segment)
        }

        state.items = rows

        state.busy = false
      }
    },
    async carbonemissions_saveit() {
      console.log("carbonemissions_saveit");

      let state = this.carbonemissions;

      state.busy = true;

      let variables = { rows: this.cleanit(state.items) };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation carbonemissions_save(
              $rows: [Carbonemission_input]
                ) {
                  carbonemissions_save(rows: $rows) {
                    id
                  }
                }
              `,
          variables,
        });
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      state.busy = false;

    },
    async carbonemissions_deleteit(ss) {
      console.log("carbonemissions_deleteit", ss);

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
                      mutation carbonemissions_delete($rows: [Carbonemission_input]) {
                        carbonemissions_delete(rows: $rows) {
                          id
                        }
                      }
                    `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.carbonemissions_load(0);
    },

    sheetlabels(tools) {

      let tool = null;

      if (tools) {
        let tabs = [
          "sheet_0",
          "sheet_1",
          "sheet_2",
          "sheet_3",
          "sheet_4",
          "sheet_5",
        ];
        tabs.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            switch (action) {
              case "sheet_0":
                tool.icon = "fa fa-plane";
                tool.label = "Flight";
                break;
              case "sheet_1":
                tool.icon = "fa fa-bed";
                tool.label = "Hotel";
                break;
              case "sheet_2":
                tool.icon = "fa fa-car";
                tool.label = "Car";
                break;
              case "sheet_3":
                tool.icon = "fa fa-bus";
                tool.label = "Transfer";
                break;
              case "sheet_4":
                tool.icon = "fa fa-train";
                tool.label = "Rail";
                break;
              case "sheet_5":
                tool.icon = "fa fa-ship";
                tool.label = "Ferry";
                break;
            }
          }
        });
      }
    },

    async download() {
      let variables = {
        name: "sheet_carbonemissions",
      };
      console.log("variables", variables);

      this.busy = true;

      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_systemsettings($name: String) {
              setup_systemsettings(name: $name) {
                data
              }
            }
          `,
          variables,
        });

        if (response.data.setup_systemsettings.length > 0) {
          let sheet = response.data.setup_systemsettings[0].data;

          let byteCharacters = atob(sheet);
          let byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          let byteArray = new Uint8Array(byteNumbers);
          let blob = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          fs.saveAs(blob, 'TEMPLATE_carbonemissions' + ".xlsx");
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
  },
};
</script>

<style></style>